import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { warningId: String }

  connect() {
    this.warningElement = document.getElementById(this.warningIdValue);
    // Store the initial checked state when the page loads
    this.initialState = this.element.querySelector('input[type="checkbox"]').checked;
  }

  toggleWarning(event) {
    const isChecked = event.target.checked;

    if (this.initialState) {
      // Scenario 1: Checkbox was initially checked
      if (!isChecked) {
        // Show warning if unchecked
        this.warningElement.style.display = 'block';
      } else {
        // Hide warning if re-checked
        this.warningElement.style.display = 'none';
      }
    } else {
      // Scenario 2: Checkbox was initially unchecked
      // No action needed as per the described behavior
      this.warningElement.style.display = 'none';
    }
  }
}
